import { ViteReactSSG } from 'vite-react-ssg';
import { routes } from './App';
import './index.css';

// Self-heal stale-chunk failures. After a deploy, a browser holding old HTML
// requests lazy route chunks by hashes that no longer exist. If the host ever
// serves HTML for those, the dynamic import throws; reload once (capped) to
// pull fresh HTML instead of showing a broken page.
if (typeof window !== 'undefined') {
  const RELOAD_KEY = 'ecmw-chunk-reloads';
  const isChunkError = (msg?: string) =>
    typeof msg === 'string' &&
    (msg.includes('is not valid JSON') ||
      msg.includes("Unexpected token '<'") ||
      msg.includes('Failed to fetch dynamically imported module') ||
      msg.includes('error loading dynamically imported module'));
  const maybeReload = () => {
    const count = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
    if (count < 2) {
      sessionStorage.setItem(RELOAD_KEY, String(count + 1));
      window.location.reload();
    }
  };
  window.addEventListener('vite:preloadError', (e) => {
    e.preventDefault();
    maybeReload();
  });
  window.addEventListener('error', (e) => {
    if (isChunkError(e?.message)) maybeReload();
  });
  window.addEventListener('unhandledrejection', (e) => {
    if (isChunkError((e?.reason as Error)?.message)) maybeReload();
  });
  window.addEventListener('load', () => {
    setTimeout(() => sessionStorage.removeItem(RELOAD_KEY), 5000);
  });
}

export const createRoot = ViteReactSSG({ routes });
